import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Fetch } from "../../../shared/Fetch";
import { JVMultiselect } from "../../../shared/JVMultiselect";
import { IWorkStreamCategory } from "./WorkStreamCategories";
import { MultiSelect } from "primereact/multiselect";

interface Props {
  open: boolean;
  singleData: IWorkStreamCategory;
  toast: any;
  onHide: () => void;
}

export const RoleMapping = ({ open, singleData, toast, onHide }: Props) => {
  const [roles, setRoles] = useState<any[]>([]);
  const [selectedRoles, setSelectedRoles] = useState<any[]>([]);
  const [mappedRoles, setMappedRoles] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [editingRoleId, setEditingRoleId] = useState<number | null>(null);
  const loadRoles = async () => {
    const response = await Fetch("Dropdown/roles", "GET", null, null, toast);
    if (response?.ok) {
      const data = await response.json();
      setRoles(data);
    }
  };

  const loadMappedRoles = async () => {
    if (!singleData.id) return;
    const response = await Fetch("Tender_Mast/GetMappedRoles", "GET", null, `categoryId=${singleData.id}`, toast);

    if (response?.ok) {
      const data = await response.json();
      setMappedRoles(data);
      setSelectedRoles(data.map((x: any) => ({ role_ID: x.role_ID, role_Name: x.role_Name })));
    }
  };

  useEffect(() => {
    if (open) {
      loadRoles();
      loadMappedRoles();
    }
  }, [open]);

  const save = async () => {
    try {
      if (!selectedRoles || selectedRoles.length === 0) {
        toast.current?.show({ severity: "warn", summary: "Validation Error", detail: "Please select at least one role", life: 3000 });
        return;
      }
      setLoading(true);
      let finalRoles = [...mappedRoles];

      if (editingRoleId !== null) {
        finalRoles = finalRoles.filter((x) => x.role_ID !== editingRoleId);

        finalRoles.push(...selectedRoles);
      } else {
        finalRoles = selectedRoles;
      }
      const body = {
        workstream_Category_ID: singleData.id,
        roles: finalRoles.map((x: any) => ({
          role_ID: x.role_ID,
        })),
      };
      //   const isUpdate = mappedRoles.length > 0;
      //   const response = await Fetch(isUpdate ? "Tender_Mast/UpdateRoleMapping" : "Tender_Mast/SaveRoleMapping", isUpdate ? "PUT" : "POST", body, null, toast);
      let response;

      if (editingRoleId !== null) {
        response = await Fetch(
          "Tender_Mast/UpdateSingleRoleMapping",
          "PUT",
          {
            workstream_Category_ID: singleData.id,
            oldRole_ID: editingRoleId,
            newRole_ID: selectedRoles[0].role_ID,
          },
          null,
          toast,
        );
      } else {
        const isUpdate = mappedRoles.length > 0;

        response = await Fetch(isUpdate ? "Tender_Mast/UpdateRoleMapping" : "Tender_Mast/SaveRoleMapping", isUpdate ? "PUT" : "POST", body, null, toast);
      }
      if (response?.ok) {
        setEditingRoleId(null);
        if (editingRoleId !== null) {
          toast.current.show({ severity: "success", summary: "Success", detail: "Role Updated Successfully", life: 3000 });
        } else {
          toast.current.show({ severity: "success", summary: "Success", detail: mappedRoles.length > 0 ? "Role Mapping Updated Successfully" : "Role Mapping Saved Successfully", life: 3000 });
        }
        loadMappedRoles();
      }
    } finally {
      setLoading(false);
    }
  };
  const onDialogHide = () => {
    setSelectedRoles([]);
    setMappedRoles([]);
    setEditingRoleId(null);
    onHide();
  };
  const removeRole = async (rowData: any) => {
    // const updatedRoles = selectedRoles.filter((x) => x.role_ID !== rowData.role_ID);
    // const body = {
    //   workstream_Category_ID: singleData.id,
    //   roles: updatedRoles.map((x) => ({
    //     role_ID: x.role_ID,
    //   })),
    // };

    setLoading(true);
    const response = await Fetch("Tender_Mast/DeleteRoleMapping", "DELETE", null, `categoryId=${singleData.id}&roleId=${rowData.role_ID}`, toast);
    setLoading(false);
    if (response?.ok) {
      toast.current.show({ severity: "success", summary: "Success", detail: "Role removed successfully", life: 3000 });
    //   setSelectedRoles(updatedRoles);
      loadMappedRoles();
    }
  };

  const editRole = (rowData: any) => {
    setEditingRoleId(rowData.role_ID);
    const role = roles.find((x) => x.role_ID === rowData.role_ID);
    if (role) {
      setSelectedRoles([role]);
    }
  };

  const actionBody = (rowData: any) => (
    <div className="flex gap-2">
      <Button icon="pi pi-pencil" className="p-button-rounded p-button-text" tooltip="Edit" onClick={() => editRole(rowData)} />

      <Button icon="pi pi-trash" className="p-button-rounded p-button-text p-button-danger" tooltip="Delete" onClick={() => removeRole(rowData)} />
    </div>
  );

  return (
    <Dialog visible={open} header={`Add Roles - ${singleData.category_Name}`} style={{ width: "60vw" }} modal onHide={onDialogHide}>
      <div className="col-6">
        <label htmlFor="assignRoles" className="font-medium block mb-2">
          Add Roles <span className="text-red-500">*</span>
        </label>
        <MultiSelect id="assignRoles" value={selectedRoles} onChange={(e) => setSelectedRoles(e.value)} options={roles} optionLabel="role_Name" placeholder="Select Roles" display="chip" filter className="w-full" panelClassName="text-base" required />
      </div>
      <div className="col-12 flex justify-content-end gap-3">
        <Button label="Submit" loading={loading} onClick={save} />
        <Button label="Close" className="p-button-outlined" onClick={onHide} />
      </div>
      <DataTable value={mappedRoles} stripedRows showGridlines size="small">
        <Column header="SN." body={(r, o) => o.rowIndex + 1} />
        <Column field="role_Name" header="Added Role" />
        <Column field="category_Name" header="Category Name" />
        <Column header="Actions" body={actionBody} style={{ width: "100px" }} />
      </DataTable>
    </Dialog>
  );
};
